import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSearchValueState, setSearchControl } from "../../features/it-user-forms/user-forms-slice";

export const useUserTyping = () => {
    const searchValue = useSelector(selectSearchValueState)
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setSearchControl({ type: "sTyping", value: true }));

        const timer = setTimeout(() => {
            dispatch(setSearchControl({ type: "sTyping", value: false }));
        }, 300);

        return () => clearTimeout(timer);
    }, [dispatch, searchValue]);
}